module.exports = __webpack_public_path__ + "static/media/8C.85e5346e.svg";